export default "__VITE_ASSET__BSwA4QC0__"